import React from "react";
import Skeleton from "react-loading-skeleton";

const TicketLoader = () => {
  return (
    <div className="eventTicketDetail_section">
      <div
        className="ticketDetail_header"
        style={{ display: "flex", alignItems: "center" }}
      >
        <h6>
          <Skeleton
            width={180}
            height={30}
            count={1}
            style={{
              "--base-color": "#ccc",
              "--highlight-color": "#f5f5f5",
            }}
            inline
          />
        </h6>
        <div>
          <span
            className="icon_for_drop_info"
            style={{ display: "flex", gap: "5px", alignItems: "center" }}
          >
            <Skeleton
              width={20}
              height={20}
              count={1}
              style={{
                "--base-color": "#ccc",
                "--highlight-color": "#f5f5f5",
              }}
              circle
            />
            <Skeleton
              width={20}
              height={20}
              count={1}
              style={{
                "--base-color": "#ccc",
                "--highlight-color": "#f5f5f5",
              }}
              circle
            />
          </span>
        </div>
      </div>
      <div className="ticket_detail_content">
        <Skeleton
          height={50}
          width={1200}
          count={1}
          style={{
            "--base-color": "#ccc",
            "--highlight-color": "#f5f5f5",
          }}
          inline
        />
      </div>
    </div>
  );
};

export default TicketLoader;
